<style>
  .Separator {
    display:block; position:absolute; overflow:visible;
    margin:0px; padding:0px; border:none; border-radius:0px;
    border-top:solid 1px black;
  }

  .Separator.vertical {
    border-top:none;
    border-left:solid 1px black;
  }
</style>

<script lang="ts">
  export let vertical:boolean = false
</script>

<div {...$$restProps} class:Separator={true} class:vertical></div>
